import {
  EntityValidationResponse,
  EntityValidatorDto,
} from '@epicuro-next/data/engagement/document-control/models';
import { createAction, props } from '@ngrx/store';
import { List } from '@epicuro-next/models/engagement';

export const patchValidators = createAction(
  '[Document Control] Patch Validators',
  props<{ entityValidators: EntityValidatorDto; list: List }>(),
);

export const patchValidatorsSuccess = createAction(
  '[Document Control] Patch Validators Success',
  props<EntityValidationResponse>(),
);

export const patchValidatorsFail = createAction(
  '[Document Control] Patch Validators Fail',
  props<{ listName: string }>(),
);
